// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_3qJ","cls2":"ImpactStatTile-cls2_JG- ImpactStatTile-cls1_3qJ"};